module.exports = __webpack_public_path__ + "gb-sct.19d377fa04ef1b8fd990.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gb-sct.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gb-sct.svg
// module chunks = styles